import React from 'react';
import { BookOpen, Users, ArrowRight } from 'lucide-react';
import { trackStudentCTA, trackTeacherCTA } from '../../services/analytics';

const FinalCTA = ({ onGetStarted }) => {
  const handleStudentClick = () => {
    trackStudentCTA('final_cta');
    onGetStarted('student');
  };

  const handleTeacherClick = () => {
    trackTeacherCTA('final_cta');
    onGetStarted('teacher');
  };

  return (
    <section data-testid="section-final-cta" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background */}
          <div className="absolute inset-0 bg-gradient-to-r from-purple-600 via-violet-600 to-purple-700" />
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMzRoLTJWMGgydjM0em0tNCAwSDBoMnYtMmgzMHYyeiIvPjwvZz48L2c+PC9zdmc+')] opacity-30" />
          
          <div className="relative px-6 py-16 sm:px-12 sm:py-20 text-center text-white">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black font-['Outfit'] mb-6">
              Ready to Transform Your Learning?
            </h2>
            <p className="text-lg sm:text-xl opacity-90 mb-10 max-w-2xl mx-auto">
              Join thousands of students and teachers using AIQuizPark to study smarter and teach better.
            </p>

            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8">
              <button
                onClick={handleStudentClick}
                data-testid="final-cta-student"
                className="group px-8 py-4 bg-white text-purple-700 rounded-xl font-bold text-lg hover:-translate-y-1 transition-all shadow-xl flex items-center justify-center gap-2"
              >
                <BookOpen className="w-5 h-5" />
                I'm a Student
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                onClick={handleTeacherClick}
                data-testid="final-cta-teacher"
                className="group px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-xl font-bold text-lg hover:-translate-y-1 hover:bg-white/20 transition-all flex items-center justify-center gap-2"
              >
                <Users className="w-5 h-5" />
                I'm a Teacher
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
            </div>

            <p className="text-sm opacity-75">
              3-day free trial • No credit card required • Cancel anytime
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
